<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <rect x="4" y="6" width="13" height="12" rx="2" stroke="currentColor" stroke-width="1.75" />
  <path d="M17 10.5L20 8.5V15.5L17 13.5V10.5Z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round" />
</svg>
